module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/flat-d41759b4759dbe4a5ceee209fd5fc31c.webp";